/*
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   Calendar day of week header component
 */

import React from 'react'

import * as style from '../style'

const DAYS_OF_WEEK = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']

export interface CalendarDayOfWeekHeaderProps {
  singleCalendar?: boolean
}

export const CalendarDayOfWeekHeader = ({ singleCalendar }: CalendarDayOfWeekHeaderProps) => {
  return (
    <div css={[style.weeksContainer, singleCalendar && style.singleWeeksContainer]}>
      {DAYS_OF_WEEK.map((day) => {
        return (
          <div css={style.dateButtonContainerDisabled} key={day}>
            <div css={style.dayOfWeek}>{day}</div>
          </div>
        )
      })}
    </div>
  )
}
